module.exports = __webpack_public_path__ + "img/icon_1_11.e7f72b2a.png";